import React from "react";
import About from "../assests/qac4.jpg";
import race1 from "../assests/comtrad1.jpg";
import race2 from "../assests/comtrad2.jpg";

const Events = () => {
  return (
    <>
      <div
        className="py-40 pl-10 pr-10"
        style={{ backgroundImage: `url(${About})` }}
      >
        <div>
          <a href="/Events">
            <button className="text-[#001ea1]  pr-7 font-bold rounded-lg  text-2xl transition-colors py-3 px-10 my-6 flex items-center bg-white">
              Upcoming Qhubeka AC Events:{" "}
            </button>
          </a>
        </div>
        {/*<div>
          <a href="https://secure.onreg.com/onreg2/front/step1.php?id=6877">
            <button className="text-[#001ea1] pb-4 font-bold hover:bg-[#001ea1] hover:text-white rounded-lg pr-9 text-2xl transition-colors py-3 px-10 my-6 flex items-center bg-white hover:scale-110 duration-1000">
              Qhubeka AC Human Rights Day Race - 21 March 2025
            </button>
         </a>
        </div>*/}
        <iframe
          src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Africa%2FJohannesburg&showTz=0&showPrint=0&src=cWh1YmVrYS5hYy5ldmVudHNAZ21haWwuY29t&src=ZW4uc2EjaG9saWRheUBncm91cC52LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23039BE5&color=%230B8043"
          style={{ border: "0", display: "inline-block" }}
          className="w-full h-screen opacity-85"
          frameborder="0"
          scrolling="no"
        ></iframe>

        <div className="text-4xl text-center font- font-bold bg-white text-[#001ea1]">
          Comrades Plan
        </div>

{/**         <div className=" bg-white bg-opacity-75 flex items-center justify-center ">
          
          <div className="grid md:grid-cols-2 items-center justify-center gap-10 w-[600px] group container ">
            <div className="  ">
              
              <img
                src={race2}
                className="   rounded-md  "
                alt="Welcome Image"
                loading="lazy"
              />
            </div>
            <div className=" bg-white rounded-md ">
              
              <img
                src={race1}
                className=" rounded-md  "
                alt="Welcome Image"
                loading="lazy"
              />
            </div>
          </div>
      </div>*/}
      </div>
    </>
  );
};

export default Events;
